import React from 'react'
import { NavLink, useLocation } from 'react-router-dom'
import ErrorPage from '../pages/ErrorPages/ErrorPage'
import { Row, Card, Result, Space, Typography } from 'antd'
import { FooterHandler } from './Footer/Footer'

const LicenseClaimSuccess = () => {
    const { state: { fromSuccess = false, numberofcalculations = false } = {} } = useLocation() || {}
    if (fromSuccess) {
        return (
            <>
                <>
                    <Row justify='center' align='middle' style={{ backgroundColor: 'white', height: '100vh' }}>
                        <Card
                            style={{
                                background: 'white',
                                width: 600,
                                boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px"
                            }}
                        >
                            <Result
                                status='success'
                                title={'Your license has been successfully redeemed!'}
                                subTitle={
                                    <Space direction='vertical'>
                                        <Typography.Text>
                                            You now have <strong>{numberofcalculations} calculations</strong> to your account!
                                        </Typography.Text>
                                        <Typography.Text>
                                            You're all set! <NavLink to='/home'>Get started with your calculation now!</NavLink>
                                        </Typography.Text>
                                    </Space>
                                }
                            />
                        </Card>
                    </Row>

                    <FooterHandler />
                </>
            </>
        )
    } else {
        return <ErrorPage />
    }
}

export default LicenseClaimSuccess
